const GoogleRecaptcha = () => {
  return;
};

export default GoogleRecaptcha;
